export default "__VITE_ASSET__DUbsdvvn__"